// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"d2e13091","917":"d620eb4f"}[chunkId] + ".chunk.js";
};